import { useEffect, useState } from "react";
import { ASSETS } from "@/data/magicalContent";

const OFFICIAL_THUMBNAILS = {
  1: "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/fbihdugx_Episode%201%20Thumbnail.png",
  2: "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/sdyeazzf_Season%201%20Episode%202%20The%20Flying%20Cloud%20Kingdom%20Adventure%20-%20Thumbnail.png",
  3: "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/7419o4k3_Season%201%20Episode%203%20THE%20DINOSAUR%20JUNGLE%20PORTAl%20-%20Thumbnail.png",
  4: "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/cfp6zll6_Season%201%20Episode%204%20Thumbnail.png",
  5: "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/2gc35iil_Episode%205%20-%20The%20Magical%20Toy%20World%20-%20Thumbnail.png",
};

export function getEpisodeThumbnail(episode, posterOverrides = {}) {
  const override = posterOverrides[String(episode.number)];
  if (override) return `${process.env.REACT_APP_BACKEND_URL}/api/media/files/${override}`;
  return OFFICIAL_THUMBNAILS[episode.number] || (episode.youtubeId ? `https://i.ytimg.com/vi/${episode.youtubeId}/hqdefault.jpg` : ASSETS.family);
}

export function usePosterOverrides() {
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/media/episode-posters`)
      .then((response) => (response.ok ? response.json() : {}))
      .then(setOverrides)
      .catch(() => {});
  }, []);
  return overrides;
}
